import React from 'react'
import Banner from '../components/Banner'
import CareersDetails from '../components/Careers/CareersDetails'

const Careers = () => {
    return (
        <>
            <Banner image={'careersbanner'} />
            <CareersDetails />
        </>
    )
}

export default Careers